import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { strings } from '/imports/strings';
import { Button } from '/imports/ui/Button';
import { NotPermittedPage } from '/imports/ui/NotPermittedPage';
import { deleteUser, listUsers, updateUser } from '/imports/api/users';
import { Page } from '/imports/ui/Page';
import { PageHeading } from '/imports/ui/PageHeading';
import { PageBody } from '/imports/ui/PageBody';
import { useUser } from '/imports/hooks';
import { createActiveFilter } from '/imports/ui/ActiveFilter';
import { Input } from '/imports/ui/Input';
import { Checkbox } from '/imports/ui/Checkbox';
import { ListMethodCatalog } from '/imports/ui/ListMethodCatalog';
import { Avatar } from '/imports/ui/Avatar';

const UsersPageStyled = Page;

export const UsersPage = () => {
  const user = useUser();
  const [superUserFilter, setSuperUserFilter] = useState<boolean>();
  const [query, setQuery] = useState<Mongo.Query<Meteor.User>>({ active: true });
  const ActiveFilter = createActiveFilter<Meteor.User>(query, setQuery);
  useEffect(() => {
    setQuery({ ...query, isSuperUser: superUserFilter });
  }, [superUserFilter]);
  if (!user?.isSuperUser && user && !Meteor.loggingIn()) {
    return <NotPermittedPage />;
  }
  return (
    <UsersPageStyled className="page" breadcrumbs={[{ path: '/users', label: strings.Users() }]}>
      <PageHeading
        left={<h1>{strings.Users()}</h1>}
        right={<div><Link to={'/users/new'}><Button>{strings.New()}</Button></Link></div>}
      />
      <PageBody>
        <ListMethodCatalog
          data={[]}
          columns={[
            { field: 'avatar', label: ' ', render: (user) => <Link to={`/users/${user._id}`}><Avatar url={user.avatar?.url} fallback={user.username?.charAt(0)} /></Link> },
            { field: 'username', render: (user) => <Link to={`/users/${user._id}`}>{user.username}</Link> },
            { field: 'firstName', input: { type: Input } }, { field: 'lastName' }, { field: 'email' },
            { field: 'isSuperUser', label: strings.SuperUser(), render: (d) => d.isSuperUser ? strings.Yes() : strings.No(), input: { type: Checkbox } },
            { field: 'active', render: (d) => d.active ? strings.Yes() : strings.No(), input: { type: Checkbox } },
          ]}
          query={query}
          listMethod={listUsers}
          updateMethod={updateUser as any}
          deleteMethod={deleteUser}
          tools={
            <div className="filters">
              <span className="filters-label">{strings.Filters()}:</span>
              <Button className={superUserFilter ? 'secondary' : 'tertiary'} onClick={() => setSuperUserFilter(!superUserFilter ? true : undefined)}>{strings.SuperUser()}</Button>
              <ActiveFilter.Component />
            </div>
          }
        />
      </PageBody>
    </UsersPageStyled>
  );
};